import { getDateOfISOWeek } from "../utils";
import { sortByKey } from "~/core/scripts/utils";
import { is768Query } from "~/core/scripts/mediaquery-helper";

const medianMinYear = 2016;
const medianMaxYear = 2019;

export function getDataByWeek(data, minDate, maxDate) {
  const currYear = new Date().getFullYear();
  // const nextYear = currYear + 1;
  const lastYear = currYear - 1;
  return data
    .filter((d) => d.year >= medianMinYear && d.year <= medianMaxYear)
    .reduce((res, item) => {
      if (res.find((d) => d.week === item.week)) {
        res = res.map((d) => ({
          ...d,
          abs: d.week === item.week ? [item.abs, ...d.abs] : d.abs,
        }));
      } else {
        // const year = item.week <= 20 ? nextYear : currYear;
        const year = item.week <= 20 ? currYear : lastYear;
        res.push({
          week: item.week,
          abs: [item.abs],
          date: getDateOfISOWeek(item.week, year),
        });
      }

      return res;
    }, [])
    .filter((d) => d.date >= minDate && d.date <= maxDate)
    .map((d) => ({
      ...d,
      absMedian: median(d.abs),
    }))
    .sort(sortByKey("date"), false);
}

export function getCurrentData(data, minDate, maxDate) {
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const lastYear = currentYear - 1;
  return data
    .filter(
      // (d) => (d.week >= 20 && d.year === currentYear) || (d.week < 20 && d.year === nextYear)
      (d) =>
        (d.week >= 20 && d.year === lastYear) ||
        (d.week < 20 && d.year === currentYear)
    )
    .map((d) => ({
      ...d,
      date: getDateOfISOWeek(d.week, d.week < 20 ? currentYear : lastYear),
    }))
    .filter((d) => d.date >= minDate && d.date <= maxDate)
    .sort(sortByKey("date", false));
}

function median(values) {
  values.sort((a, b) => {
    return a - b;
  });

  if (!values.length) return 0;

  const center = Math.floor(values.length / 2);

  if (values.length % 2) {
    return values[center];
  } else {
    return (values[center - 1] + values[center]) / 2;
  }
}

export function getXTicks(currentYear, isTeaser) {
  return [
    {
      label: "Oktober",
      value: new Date(currentYear, 9, 1),
      isMobile: true,
    },
    {
      label: "November",
      value: new Date(currentYear, 10, 1),
    },
    {
      label: "Dezember",
      value: new Date(currentYear, 11, 1),
    },
    {
      label: "Januar",
      value: new Date(currentYear + 1, 0, 1),
      isMobile: true,
    },
    {
      label: "Februar",
      value: new Date(currentYear + 1, 1, 1),
    },
    {
      label: "März",
      value: new Date(currentYear + 1, 2, 1),
      isMobile: true,
    },
    {
      label: "April",
      value: new Date(currentYear + 1, 3, 1),
    },
    {
      label: "Mai",
      value: new Date(currentYear + 1, 4, 1),
      isMobile: true,
    },
  ].filter((d) => (!is768Query() || isTeaser ? d.isMobile : true));
}
